import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root'
})
export class AnnuaireServiceService {
  host_Annuaire = `${environment.API_URI}/api/annuaire`;

  constructor(private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getAllAnnuaireByCodeDo(code_interne: number) {
    const url = `${this.host_Annuaire}/select/all/${code_interne}`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }
  disableAnnuaire(codeInternes: number[]) {
    const url = `${this.host_Annuaire}/disable`;
    const body = { code_interne: codeInternes };
    return this.http.post(url, body, { headers: this.getAuthHeaders() });
  }
  enableAnnuaire(codeInternes: number[]) {
    const url = `${this.host_Annuaire}/enable`;
    const body = { code_interne: codeInternes };
    return this.http.post(url, body, { headers: this.getAuthHeaders() });
  }

  updateAnnuaire(code_interne: number, Annuaire: any) {
    const url = `${this.host_Annuaire}/update/${code_interne}`;
    return this.http.put(url, Annuaire, { headers: this.getAuthHeaders() });
  }

  addAnnuaire(Annuaire: any) {
    const url = `${this.host_Annuaire}/add`;
    return this.http.post(url, Annuaire, { headers: this.getAuthHeaders() });
  }

  exportAnnuaires(code_interne: number) {
    const url = `${this.host_Annuaire}/export/${code_interne}`;
    return this.http.get(url, {
      responseType: 'blob',
      headers: this.getAuthHeaders()
    });
  }

  exportTemplateAnnuaire() {
    const url = `${this.host_Annuaire}/export/template`;
    return this.http.get(url, {
      responseType: 'blob',
      headers: this.getAuthHeaders()
    });
  }

  importCsvAnnuaire(code_do : number,add_on:string, file: File): Observable<HttpEvent<any>> {
    const url = `${this.host_Annuaire}/bulk-import/`;
    const formData = new FormData();
    formData.append('csvAnnuaireFile', file);

    const req = new HttpRequest('POST', url + code_do+'/' + add_on, formData, {
      reportProgress: true,
      headers: this.getAuthHeaders(),
      responseType: 'json'
    });

    return this.http.request(req);
  }

 deleteAnnuaire(code_Internes: number[]) {
  const url = `${this.host_Annuaire}/delete`;
  const body = { code_interne: code_Internes };
  const headers = this.getAuthHeaders();

  return this.http.post(url, body, { headers });
}
}
